<template>
    <section>
        <modal  v-if="showModal" @close="showModal = false"
                v-on:keydown.esc="showModal = false"
                :title="info.title"
                :sizeOfModal="'small'"
                :showElement="showModal">
            <template v-slot:modalContent>
                <form class="ui form">
                    <div class="field">
                        <label>Descripción (opcional)</label>
                        <textarea rows="2" v-model="record.motive"></textarea>
                    </div>
                </form>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button :color="info.color" @click="classify()">{{ info.accept }}</sui-button>
                    <sui-button @click="classify(true)">Cancelar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>

<script>

import Modal from '@/components/Helpers/Modal.vue'
import Utils from '@/common/Utils.js'
import RugGuaranteeToBluStatus from '@/common/RugGuaranteeToBluStatus'

export default {
    name: 'ClassifyRugGuaranteeToBlu',
    components: { Modal },
    props: ['showModal', 'status', 'rugGuaranteeToBlu'],

    data () {
        return {
            Utils: Utils,
            record: { cancel: false },
            RugGuaranteeToBluStatus
        }
    },

    methods: {
        classify (cancel = false) {
            if (cancel) {
                this.record.cancel = true
                this.$emit('modalResponse', this.record)
                return
            }
            this.$swal({
                title: '¿Esta seguro?',
                icon: 'question',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showCloseButton: false
            }).then(async (result) => {
                if (result.value) {
                    this.record.cancel = false
                    this.$emit('modalResponse', this.record)
                } else {
                    this.record.cancel = true
                    this.$emit('modalResponse', this.record)
                }
            })
        }
    },
    computed: {
        info () {
            if (this.status === this.RugGuaranteeToBluStatus.INCLUDE) {
                return {
                    title: 'Rechazar',
                    accept: 'Rechazar',
                    color: 'red'
                }
            } else if (this.status === RugGuaranteeToBluStatus.IGNORE) {
                return {
                    title: 'Aprobar',
                    accept: 'Aprobar',
                    color: 'blue'
                }
            }
            return {
                title: 'Indefinido',
                accept: 'Indefinido',
                color: 'blue'
            }
        }
    }
}
</script>
